import { render, staticRenderFns } from "./PublisherScreen.vue?vue&type=template&id=2905f6c6"
import script from "./PublisherScreen.vue?vue&type=script&lang=js"
export * from "./PublisherScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports